import { AgentCommissionVersionDto } from "app/shared/model/AgentCommissionDto";
import { RatesTable } from "app/pages/AgentPricing/models";

export type PublishedVersionsState = {
    status: PublishedVersionsFetchStatus
    versions: AgentCommissionVersion[] 
    selected: string
}

export enum PublishedVersionsFetchStatus {
    Running = 'Running', 
    Errored = 'Errored', 
    Success = 'Success',
}

export interface AgentCommissionVersion {
    name: string
    rates: RatesTable
    lastUpdatedBy: string
    lastUpdatedDate: string
    ratesFor?: string
    isCurrent?: boolean
}
